// extracted by mini-css-extract-plugin
export default {"button":"SmallButton_button__V7V0C"};